import { uri } from '../../api-endpoint';
import {
  ICompanyAPIValidationError,
  ICompanyFromAPISuccessResponse
} from '../../type-conversion/company/from-api-repsonse';
import { CompanyAPIRequestBody } from '../../type-conversion/company/to-api-request-body';
import { updateTemplateFn } from '../common';

export const updateCompany = (token: string) => (companyId: number) =>
  updateTemplateFn(
    token,
    uri.companyById(companyId),
    CompanyAPIRequestBody,
    ICompanyFromAPISuccessResponse,
    ICompanyAPIValidationError
  );
